module.exports = __webpack_public_path__ + "static/media/Facebook3.43a5f582.png";